import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles, typographyStyles} from "@webs/components-library/theming";

@customElement('webs-header-four')
export class HeaderFour extends LitElement {
  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    css`
      .m-header-four {
        padding: 2.5rem 0;
      }

      .m-header-four__content {
        margin-bottom: 1.5rem
      }

      @media only screen and (min-width: 768px){
          .m-header-four {
             padding: 4rem 0;
          }

          .m-header-four__content {
              margin-bottom: 0;
          }
      }
      @media only screen and (min-width: 1441px){
      :host {
        overflow-x: unset;
      }
     }
    `
  ];

  @property({ attribute: 'space-top' })
  spaceTop = 'm'

  @property({ attribute: 'space-bottom' })
  spaceBottom = 'm';

  protected render(): unknown {
    return html`
      <section class="m-header-four ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
        <div class="container">
          <webs-grid-row >
            <webs-grid-column sm="7" md="6"  class="m-header-four__content">
              <slot name="breadcrumbs"></slot>
              <slot name="title"></slot>
            </webs-grid-column>
            <webs-grid-column sm="5" md="4" md-offset="2" class="m-header-four__card">
                <slot name="card"></slot>
            </webs-grid-column>
          </webs-grid-row>
        </div>
      </section>
    `
  }
}
